import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import Immutable from 'immutable';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { catalogBibShape } from '@bibliocommons/bc-prop-types';
import Heading from '@bibliocommons/heading';
import {
  FullScreenOverlayBody,
  FullScreenOverlayHeader,
  FullScreenOverlayContent
} from '@bibliocommons/base-full-screen-overlay';
import { TableStencil } from '@bibliocommons/table';
import BibSeries from 'app/components/bibs/shared/BibSeries';

import './SameSeriesOverlay.scss';

export default class SameSeriesOverlay extends React.PureComponent {
  componentDidMount() {
    this.props.seriesInfoActions.fetchSeriesInfo(this.props.catalogBib.get('metadataId'));
  }

  render() {
    const { series, catalogBib, isFetching } = this.props;
    const bibs = series.get('seriesEntries', Immutable.List());

    return (
      <FullScreenOverlayBody className="cp-same-series-overlay">
        <FullScreenOverlayHeader title={<FormattedMessage id="in_the_same_series" />} />
        <FullScreenOverlayContent size="small">
          {isFetching ? (
            <TableStencil />
          ) : (
            <>
              <Heading tagName="h3" size="moderate" variant className="same-series-heading">
                {series.get('seriesTitle')}
              </Heading>
              <BibSeries bibs={bibs} catalogBib={catalogBib} />
            </>
          )}
        </FullScreenOverlayContent>
      </FullScreenOverlayBody>
    );
  }
}

SameSeriesOverlay.propTypes = {
  isFetching: PropTypes.bool.isRequired,
  series: ImmutablePropTypes.map.isRequired,
  catalogBib: catalogBibShape,
  seriesInfoActions: PropTypes.objectOf(PropTypes.func)
};
